/**
 * Based on [Jason Kleban](https://gist.github.com/JasonKleban/50cee44960c225ac1993c922563aa540).
 */
export interface ISignal<T> {
  connect(handler: { (data: T): void }) : void
  disconnect(handler: { (data: T): void }) : void
}

export class Signal<T> implements ISignal<T> {
  private handlers: { (data: T): void; }[] = []

  public connect(handler: { (data: T): void }) : void {
    this.handlers.push(handler)
  }

  public disconnect(handler: { (data: T): void }) : void {
    this.handlers = this.handlers.filter(h => h !== handler)
  }

  public clear() : void {
    this.handlers.splice(0, this.handlers.length)
  }

  public emit(data: T) {
    this.handlers.slice(0).forEach(h => h(data))
  }

  public expose() : ISignal<T> {
    return this
  }
}
